import moment from "moment";
import Constants from "../config/constants";
import DateUtilsLib from "./DateUtils.lib";

function mapSentBy(raw) {
  const v = (raw || "").toLowerCase();
  if (v === "user") return "USER";
  return "ADMIN";
}

function isWallClockOnlyTimeString(s) {
  if (typeof s !== "string") return false;
  const t = s.trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(t) || t.includes("T")) return false;
  return /^\d{1,2}:\d{2}(:\d{2})?$/.test(t);
}

function parseFlowMessageTime(mt) {
  if (mt == null || mt === "") {
    return { createdAt: null, createdAtText: "" };
  }
  const s = String(mt).trim();
  if (isWallClockOnlyTimeString(s)) {
    return { createdAt: null, createdAtText: s };
  }
  const d = new Date(mt);
  if (Number.isFinite(d.getTime())) {
    return {
      createdAt: d,
      createdAtText: DateUtilsLib.changeTimezoneFromUtc(d, Constants.TIME_ZONE, "DD MMM, HH:mm"),
    };
  }
  return { createdAt: null, createdAtText: s };
}

/**
 * Maps a whatsapp-api_flow conversation to the shape used by the CRM panel.
 * @param {object|null} conv
 * @param {object|null} contactEntity — from CRM contacts/detail when available
 */
export function mapFlowConversation(conv, contactEntity = null) {
  if (!conv) return null;
  const id = conv.id != null ? String(conv.id) : "";
  const lastTime = conv.last_message_time ? new Date(conv.last_message_time) : null;
  const name = conv.contact_name || contactEntity?.name || conv.contact || "";
  return {
    id,
    name,
    contact: conv.contact,
    country_code: conv.country_code || "",
    last_message: conv.last_message || "",
    last_message_time: conv.last_message_time,
    contact_id: conv.contact_id,
    is_escalated: false,
    posted_ago: lastTime && Number.isFinite(lastTime.getTime()) ? moment(lastTime).fromNow() : "",
    contactEntity: contactEntity
      ? {
          id: contactEntity.id ?? contactEntity._id,
          name: contactEntity.full_name || contactEntity.name,
          contact: contactEntity.full_contact || contactEntity.contact,
        }
      : conv.contact_id
        ? {
            id: conv.contact_id,
            name: conv.contact_name || "",
            contact: conv.contact ? `${conv.country_code || ""}${conv.contact}` : "",
          }
        : null,
  };
}

/**
 * Maps Flow API message rows for the panel.
 */
export function mapFlowMessages(messages) {
  return (messages || []).map((m) => {
    const { createdAt, createdAtText } = parseFlowMessageTime(m.message_time);
    return {
      id: m.id != null ? String(m.id) : m.message_id,
      conversation_id: m.conversation_id != null ? String(m.conversation_id) : undefined,
      message_id: m.message_id,
      media_path: m.media_path || m.media_url || "",
      contact: m.contact,
      message: m.message != null ? m.message : m.summary || "",
      summary: m.summary,
      media_url: m.media_url,
      map_url: m.map_url,
      mime_type: m.mime_type,
      file_size: m.file_size,
      message_type: m.message_type || "TEXT",
      message_time: m.message_time,
      sent_by: mapSentBy(m.sent_by),
      status: m.status,
      reply_to: m.reply_to,
      metadata: m.metadata,
      createdAt,
      createdAtText,
    };
  });
}
